import 'css-chunksrc/client/pages/projectPage/resourcesPage/sidebar/group/styles.scss';export default {
  "group": "_group_nz754_1",
  "main": "_main_nz754_11",
  "selected": "_selected_nz754_22",
  "name": "_name_nz754_22",
  "groupIcon": "_groupIcon_nz754_26",
  "menu": "_menu_nz754_42",
  "droppable": "_droppable_nz754_51"
};